import type { ComponentType } from "react";
import type { EducationData } from "app/pages/sales-intelligence/types/educationData";

type ExpectedConsumerProps = {
    educationData: Readonly<EducationData>;
};

type WrapperProps<P> = Omit<P, "educationData"> & { stateId: string };

export default function withEducationDataFromWindow<P extends ExpectedConsumerProps>(
    EducationBarCmp: ComponentType<P>,
) {
    return function WrappedWithEducationDataFromWindow(props: WrapperProps<P>) {
        const { stateId, ...rest } = props;
        const educationData: Readonly<EducationData> = (window as any).education?.[stateId] ?? {};

        return (
            <EducationBarCmp
                {...(rest as unknown as P)}
                educationData={educationData}
            />
        );
    };
}
